export default __webpack_public_path__ + "static/media/SCOOT.04d40b61.png";